var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-thumbnail",attrs:{"width":"40","src":_vm.flagPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }